import styled from "styled-components";

export const gradient = "linear-gradient(144.01deg, #ffc951 0%, #c94daa 130%)";

export const HeaderWrap = styled.header<{ $theme: "dark" | "light" }>`
  position: sticky;
  top: 0;
  z-index: 100;
  background: var(--mp-background, #121416CC);
  border-bottom: 1px solid var(--mp-border, rgba(23, 23, 23, 0.08));
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  height: 64px;
  min-height: 64px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 0 12px;
  }
`;

export const HeaderContent = styled.div`
  width: 100%;
  max-width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  @media (max-width: 768px) {
    gap: 4px;
  }
`;

export const LogoArea = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin-right: 12px;

  @media (max-width: 768px) {
    gap: 6px;
    margin-right: 0;
  }
`;

export const LogoImg = styled.img`
  height: 36px;
  width: auto;
  object-fit: contain;
  flex-shrink: 0;

  @media (max-width: 480px) {
    height: 28px;
  }
`;

export const LogoText = styled.span<{ $theme: "dark" | "light" }>`
  font-family: Montserrat, sans-serif;
  font-size: 18px;
  font-weight: 800;
  color: ${p => p.$theme === "dark" ? "#ffffff" : "#171717"};
  letter-spacing: -0.02em;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 15px;
  }

  @media (max-width: 480px) {
    font-size: 13px;
  }

  @media (max-width: 350px) {
    display: none;
  }
`;

export const LogoBadge = styled.span`
  font-size: 10px;
  font-weight: 700;
  background: #f1f2f6;
  color: #57606f;
  padding: 3px 8px;
  border-radius: 100px;
  text-transform: uppercase;
  letter-spacing: 0.05em;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const NavTabs = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  margin: 0 auto;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const NavTab = styled.button<{ $active?: boolean; $theme: "dark" | "light" }>`
  background: none;
  border: none;
  font-family: 'Liberation Serif', serif;
  font-weight: 600;
  font-style: normal;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.7px;
  vertical-align: middle;
  cursor: pointer;
  padding: 6px 4px;
  transition: all 0.2s;
  
  color: ${p => p.$theme === "dark" ? "#D2C5AF" : "#434655"};
  opacity: ${p => p.$active ? 1 : 0.7};
  border-bottom: 2px solid ${p => p.$active ? (p.$theme === "dark" ? "#D2C5AF" : "#434655") : "transparent"};

  &:hover {
    opacity: 1;
  }
`;

export const SearchBarContainer = styled.form<{ $theme: "dark" | "light" }>`
  display: flex;
  align-items: center;
  background: ${p => p.$theme === "dark" ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.05)"};
  border: 1px solid ${p => p.$theme === "dark" ? "rgba(255, 255, 255, 0.15)" : "rgba(0, 0, 0, 0.1)"};
  border-radius: 100px;
  padding: 4px 12px;
  width: 200px;
  transition: all 0.2s;
  position: relative;

  &:focus-within {
    border-color: ${p => p.$theme === "dark" ? "#D2C5AF" : "#434655"};
    background: ${p => p.$theme === "dark" ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.08)"};
  }

  @media (max-width: 1024px) {
    width: 150px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const SearchBarInput = styled.input<{ $theme: "dark" | "light" }>`
  background: none;
  border: none;
  outline: none;
  width: 100%;
  font-family: inherit;
  font-size: 13px;
  color: ${p => p.$theme === "dark" ? "#ffffff" : "#171717"};

  &::placeholder {
    color: ${p => p.$theme === "dark" ? "rgba(255, 255, 255, 0.4)" : "rgba(0, 0, 0, 0.4)"};
  }
`;

export const SearchBarButton = styled.button<{ $theme: "dark" | "light" }>`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: ${p => p.$theme === "dark" ? "rgba(255, 255, 255, 0.6)" : "rgba(0, 0, 0, 0.6)"};

  &:hover {
    color: ${p => p.$theme === "dark" ? "#D2C5AF" : "#434655"};
  }
`;

export const SearchResultsDropdown = styled.div<{ $theme: "dark" | "light" }>`
  position: absolute;
  top: 42px;
  left: 0;
  right: 0;
  background: var(--mp-cardBackground, white);
  border: 1px solid var(--mp-border, rgba(23, 23, 23, 0.08));
  border-radius: 12px;
  padding: 8px;
  min-width: 280px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  gap: 6px;
  z-index: 10001;
`;

export const SearchResultSectionTitle = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--mp-textColor, rgba(23, 23, 23, 0.4));
  padding: 4px 8px;
`;

export const SearchResultItem = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: var(--mp-bodyBackground, #f5f6fa);
  }

  .title {
    font-size: 12px;
    font-weight: 700;
    color: var(--mp-headingColor, #171717);
  }

  .subtitle {
    font-size: 10px;
    color: var(--mp-textColor, rgba(23, 23, 23, 0.5));
  }
`;

export const SearchNoResults = styled.div`
  font-size: 11px;
  color: var(--mp-textColor, rgba(23, 23, 23, 0.5));
  padding: 8px;
  text-align: center;
`;

export const NotificationBtn = styled.button<{ $theme: "dark" | "light" }>`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${p => p.$theme === "dark" ? "rgba(255, 255, 255, 0.8)" : "rgba(0, 0, 0, 0.8)"};
  padding: 8px;
  border-radius: 50%;
  transition: all 0.2s;

  &:hover {
    background: ${p => p.$theme === "dark" ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.05)"};
    color: ${p => p.$theme === "dark" ? "#D2C5AF" : "#434655"};
  }
`;

export const ThemeToggleSwitch = styled.button<{ $isDark: boolean }>`
  width: 52px;
  height: 28px;
  border-radius: 100px;
  background: ${p => p.$isDark ? "linear-gradient(135deg, #1f2937 0%, #111827 100%)" : "linear-gradient(135deg, #f7f8fc 0%, #edf2f7 100%)"};
  border: 1.5px solid ${p => p.$isDark ? "rgba(255, 255, 255, 0.15)" : "rgba(216, 99, 186, 0.3)"};
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: ${p => p.$isDark ? "inset 0 2px 4px rgba(0,0,0,0.5)" : "inset 0 2px 4px rgba(0,0,0,0.06)"};

  &:hover {
    transform: scale(1.04);
  }
`;

export const ThemeToggleKnob = styled.div<{ $isDark: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${p => p.$isDark ? "linear-gradient(135deg, #FFC951 0%, #C94DAA 100%)" : "linear-gradient(135deg, #FFD573 0%, #D863BA 100%)"};
  position: absolute;
  top: 2.5px;
  left: ${p => p.$isDark ? "26px" : "3.5px"};
  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s ease;
  box-shadow: 0 2px 6px ${p => p.$isDark ? "rgba(201, 77, 170, 0.4)" : "rgba(216, 99, 186, 0.4)"};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;

  svg {
    stroke: white !important;
  }
`;

export const ProfileCircleWrap = styled.div<{ $theme: "dark" | "light" }>`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${p => p.$theme === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.08)"};
  border: 1.5px solid ${p => p.$theme === "dark" ? "#D2C5AF" : "#434655"};
  color: ${p => p.$theme === "dark" ? "#D2C5AF" : "#434655"};
  font-weight: 700;
  font-size: 13px;
  flex-shrink: 0;
  box-sizing: border-box;

  @media (max-width: 480px) {
    width: 30px;
    height: 30px;
  }
`;

export const ActionsArea = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  
  @media (max-width: 768px) {
    gap: 6px;
  }

  @media (max-width: 480px) {
    gap: 4px;
  }
`;

const BaseBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 38px;
  padding: 0 16px;
  border-radius: 10px;
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);

  @media (max-width: 480px) {
    padding: 0 10px;
    font-size: 12px;
    height: 34px;
  }
`;

export const ProfileBtn = styled(BaseBtn)`
  border: 1px solid rgba(23, 23, 23, 0.08);
  background: white;
  color: #171717;

  &:hover {
    background: #f7f8fc;
    border-color: rgba(23, 23, 23, 0.15);
  }

  @media (max-width: 480px) {
    padding: 0;
    width: 34px;
    height: 34px;
    span {
      display: none;
    }
  }
`;

export const CreateProfileBtn = styled(BaseBtn)`
  border: none;
  background: ${gradient};
  color: white;
  box-shadow: 0 4px 12px rgba(201, 77, 170, 0.2);

  &:hover {
    opacity: 0.95;
    transform: translateY(-1px);
  }

  @media (max-width: 480px) {
    padding: 0;
    width: 34px;
    height: 34px;
    span {
      display: none;
    }
  }
`;

export const LoginBtn = styled(BaseBtn)`
  border: none;
  background: var(--mp-heroBtnBg, ${gradient});
  color: var(--mp-heroBtnColor, white);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);

  &:hover {
    opacity: 0.92;
    transform: translateY(-1px);
  }
`;

export const LogoutIconBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  border: 1px solid rgba(239, 68, 68, 0.2);
  background: rgba(239, 68, 68, 0.05);
  color: #ef4444;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #ef4444;
    color: white;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(23, 23, 23, 0.55);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;

export const ModalCard = styled.div`
  background: white;
  width: 100%;
  max-width: 480px;
  border-radius: 24px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.18);
  border: 1px solid rgba(23, 23, 23, 0.05);
  overflow-y: auto;
  max-height: 90vh;
  animation: modalFadeIn 0.3s cubic-bezier(0.16, 1, 0.3, 1) both;

  @keyframes modalFadeIn {
    from {
      opacity: 0;
      transform: translateY(16px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const ModalTopArea = styled.div`
  background: ${gradient};
  padding: 36px 24px 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
`;

export const CloseBtn = styled.button`
  position: absolute;
  top: 18px;
  right: 18px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  cursor: pointer;
  color: white;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;

  &:hover {
    background: rgba(255, 255, 255, 0.35);
  }
`;

export const ProfileBody = styled.div`
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const AvatarCircle = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c94daa;
  font-size: 32px;
  font-weight: 800;
  margin-bottom: 12px;
  box-shadow: 0 8px 24px rgba(201, 77, 170, 0.3);
`;

export const ProfileImg = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid white;
  margin-bottom: 12px;
  box-shadow: 0 8px 24px rgba(201, 77, 170, 0.3);
`;

export const ProfileName = styled.h4`
  margin: 0 0 6px;
  font-family: Urbanist, sans-serif;
  font-size: 24px;
  font-weight: 800;
  color: white;
  text-align: center;
`;

export const ProfileTypeBadge = styled.span`
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(4px);
  color: white;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 100px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const BioSection = styled.div`
  background: #f7f8fc;
  border-left: 3px solid #c94daa;
  padding: 12px 16px;
  border-radius: 0 12px 12px 0;
`;

export const BioText = styled.p`
  margin: 0;
  font-family: Urbanist, sans-serif;
  font-size: 14px;
  color: rgba(23, 23, 23, 0.7);
  line-height: 1.5;
  font-style: italic;
`;

export const DetailsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const DetailItem = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  background: #fdfdfd;
  padding: 12px 16px;
  border-radius: 14px;
  border: 1px solid rgba(23, 23, 23, 0.05);
`;

export const DetailIconWrap = styled.div`
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: rgba(201, 77, 170, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const DetailContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const DetailLabel = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 10px;
  color: rgba(23, 23, 23, 0.4);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const DetailValue = styled.span`
  font-family: Urbanist, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #171717;
`;

export const TagsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TagsLabel = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: rgba(23, 23, 23, 0.45);
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const TagChip = styled.span`
  background: rgba(201, 77, 170, 0.07);
  color: #c94daa;
  font-family: Urbanist, sans-serif;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 6px;
`;

export const PortfolioSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-top: 1px solid rgba(23, 23, 23, 0.06);
  padding-top: 16px;
`;

export const PortfolioLabel = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: rgba(23, 23, 23, 0.45);
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const PortfolioList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const PortfolioLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f7f8fc;
  padding: 10px 14px;
  border-radius: 8px;
  color: #171717;
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s;

  &:hover {
    background: rgba(201, 77, 170, 0.05);
    color: #c94daa;
    padding-left: 18px;
  }
`;

export const QuickActionsTitle = styled.h5`
  margin: 12px 0 0;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: rgba(23, 23, 23, 0.45);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-top: 1px solid rgba(23, 23, 23, 0.06);
  padding-top: 16px;
`;

export const QuickActionsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
`;

export const QuickActionCard = styled.div`
  background: #f8f9fa;
  border: 1px solid rgba(23, 23, 23, 0.05);
  padding: 12px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  display: flex;
  align-items: flex-start;
  gap: 10px;

  &:hover {
    transform: translateY(-2px);
    background: white;
    border-color: rgba(201, 77, 170, 0.3);
    box-shadow: 0 8px 20px rgba(201, 77, 170, 0.08);

    & > div {
      background: ${gradient};
      color: white;
    }
  }
`;

export const ActionIconWrap = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: rgba(201, 77, 170, 0.1);
  color: #c94daa;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s;
`;

export const ActionCardText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  strong {
    font-size: 12px;
    font-weight: 700;
    color: #171717;
  }

  span {
    font-size: 10px;
    color: rgba(23, 23, 23, 0.5);
    line-height: 1.2;
  }
`;

export const NoProfileCTA = styled.div`
  background: rgba(255, 193, 7, 0.08);
  border: 1px dashed rgba(255, 193, 7, 0.4);
  padding: 16px;
  border-radius: 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const CTAWarningText = styled.span`
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #b7791f;
`;

export const ModalCreateProfileBtn = styled.button`
  background: ${gradient};
  color: white;
  border: none;
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  font-weight: 700;
  padding: 8px 18px;
  border-radius: 100px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(201, 77, 170, 0.2);
  transition: all 0.2s;

  &:hover {
    transform: translateY(-1px);
    opacity: 0.95;
  }
`;

export const ModalLogoutBtn = styled.button`
  width: 100%;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 10px;
  border: 1px solid rgba(239, 68, 68, 0.2);
  background: rgba(239, 68, 68, 0.05);
  color: #ef4444;
  font-family: Urbanist, sans-serif;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #ef4444;
    color: white;
    border-color: #ef4444;
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);
  }
`;

export const ConfirmCard = styled.div`
  background: white;
  width: 100%;
  max-width: 380px;
  border-radius: 20px;
  box-shadow: 0 20px 48px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(23, 23, 23, 0.05);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  animation: modalFadeIn 0.25s cubic-bezier(0.16, 1, 0.3, 1) both;
`;

export const ConfirmHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const LogOutIconWrap = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(201, 77, 170, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ConfirmTitle = styled.h4`
  margin: 0;
  font-family: Urbanist, sans-serif;
  font-size: 18px;
  font-weight: 800;
  color: #171717;
`;

export const ConfirmBodyText = styled.p`
  margin: 0;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  color: rgba(23, 23, 23, 0.6);
  line-height: 1.5;
`;

export const ConfirmActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 4px;
`;

export const CancelConfirmBtn = styled.button`
  height: 38px;
  padding: 0 16px;
  border: 1.5px solid rgba(23, 23, 23, 0.12);
  border-radius: 9px;
  background: white;
  color: rgba(23, 23, 23, 0.65);
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f7f8fc;
    border-color: rgba(23, 23, 23, 0.2);
  }
`;

export const ConfirmLogoutBtn = styled.button`
  height: 38px;
  padding: 0 18px;
  border: none;
  border-radius: 9px;
  background: ${gradient};
  color: white;
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(201, 77, 170, 0.2);
  transition: all 0.2s;

  &:hover {
    opacity: 0.95;
    transform: translateY(-1px);
  }
`;

export const MobileMenuBtn = styled.button<{ $theme: "dark" | "light" }>`
  display: none;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 8px;
  border: 1px solid ${p => p.$theme === "dark" ? "rgba(255, 255, 255, 0.15)" : "rgba(23, 23, 23, 0.1)"};
  background: ${p => p.$theme === "dark" ? "rgba(255, 255, 255, 0.05)" : "white"};
  color: ${p => p.$theme === "dark" ? "#ffffff" : "#171717"};
  cursor: pointer;
  flex-shrink: 0;

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const DropdownMenu = styled.div<{ $theme: "dark" | "light" }>`
  position: absolute;
  top: 48px;
  right: 0;
  background: var(--mp-cardBackground, white);
  border: 1px solid var(--mp-border, rgba(23, 23, 23, 0.08));
  border-radius: 12px;
  padding: 6px;
  min-width: 150px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  gap: 4px;
  z-index: 1000;
`;

export const DropdownItem = styled.button<{ $desktopOnly?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 12px;
  background: none;
  border: none;
  border-radius: 8px;
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: var(--mp-headingColor, #171717);
  text-align: left;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: var(--mp-bodyBackground, #f5f6fa);
  }

  ${p => p.$desktopOnly && `
    @media (max-width: 768px) {
      display: none;
    }
  `}
`;

export const DropdownDivider = styled.div<{ $desktopOnly?: boolean }>`
  height: 1px;
  background: var(--mp-border, rgba(23, 23, 23, 0.08));
  margin: 4px 0;

  ${p => p.$desktopOnly && `
    @media (max-width: 768px) {
      display: none;
    }
  `}
`;
